import React, {Button, Component, useState } from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import Table from '../../../widgets/tables/Table';
import WaitDialog from '../../../widgets/WaitDialog';
import RataDaVerificareWidget from "../../../widgets/RataDaVerificareStatusWidget";

import GetStudenti from '../../../services/getStudentiForBilling';
import getCorsi from '../../../services/getCorsi';
import getRataStatusAll from "../../../services/getRataStatusAll";
import moment from 'moment';

export default class DaVerificare extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: []
    }

    this.grid = 2;

    this.pdfElements = [];

    this.studenti = [];
    this.pageTitle = "Pagamenti da verificare";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });
    
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {

    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.rataStatus = await getRataStatusAll(username, token);
    this.rataStatus = this.rataStatus.filter(r => r.status == 'DA VERIFICARE');
    this.studenti = await GetStudenti(username, token);
    this.corsi = await getCorsi(username, token);
    
    this.rataStatus.forEach((rata, index) => {
      var studente = this.studenti.find(s => s.id == rata.id_studente);
      var corso = this.corsi.find(c => c.id == rata.id_corso);
      rata.nome = studente.nome;
      rata.cognome = studente.cognome;
      if (corso !== undefined) {
        rata.corso = corso.name;
      } else {
        rata.corso = "";
      }

      this.rataStatus[index] = rata;
    });

    this.rataStatus.forEach((corso, index) => {
      var data = corso.data;
      
      data = moment(data, "DD-MM-yyyy").format("DD-MM-yyyy");
      corso.data = data;
      this.rataStatus[index] = corso;
    });

    this.setState({
      rataStatusWidgetVisible: false
    });
  }

  async componentDidMount(){
    await this.reload();

  }


  render () {

    var headCells = [
      { id: 'nome', numeric: false, disablePadding: true, label: 'Nome' },
      { id: 'cognome', numeric: true, disablePadding: false, label: 'Cognome' },
      { id: 'corso', numeric: true, disablePadding: false, label: 'Corso' },
      { id: 'data', numeric: true, disablePadding: false, label: 'Data' },
      { id: 'importo', numeric: true, disablePadding: false, label: 'Importo' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    this.searchCols = ['nome', 'cognome', 'corso'];

    if (this.rataStatus == undefined) return null;

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={this.pageTitle} />

        <Table headCells={headCells} searchCols={this.searchCols} calendar={false} pdf={false} excel={false} mail={false} phone={false} rows={this.rataStatus} 
              onEventClick={(row) => {

                var rata = this.rataStatus.find(r => r.id == row);
                if (rata.corso !== "") {
                    var studente = this.studenti.find(s => s.id == rata.id_studente);
                    var corso = this.corsi.find(c => c.id == rata.id_corso);

                    this.setState({
                      rataStatusWidgetVisible: true,
                      status: rata.status,
                      rata: {
                          studente: studente,
                          data: rata.data,
                          importo: rata.importo,
                          corso: corso,
                          files: rata.files,
                          note: rata.note
                      }
                  });
                }
              }}
        />

        <RataDaVerificareWidget isStudent={true} show={this.state.rataStatusWidgetVisible} rata={this.state.rata} status={this.state.status} 
            onClose={() => {
                this.setState({rataStatusWidgetVisible: false});
                this.reload();
            }}
        />

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </>
    );
  }
}

